import React from 'react';
import IndexTableContainer from '../../shared/components/tables/IndexTableContainer';

const ProductLinesIndexContainer = () => {
  const createRows = (list) => (
    list.map((line) => {
      const {
        id,
        name,
        image,
      } = line;

      return (
        <tr key={id}>
          <td>
            {
              image
                ? (
                  <img
                    src={image}
                    alt="asdf"
                    style={{
                      verticalAlign: 'middle',
                      width: 50,
                      height: 50,
                      borderRadius: 12,
                    }}
                  />
                )
                : (
                  <div
                    style={{
                      backgroundColor: '#ccc',
                      borderRadius: 12,
                      width: 50,
                      height: 50,
                      textAlign: 'center',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 25,
                        lineHeight: 1,
                        position: 'relative',
                        top: 12,
                      }}
                    >
                      {name.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )
            }
          </td>
          <td>{name}</td>
        </tr>
      );
    })
  );

  const buildBadgeList = (filter, defaultFilter) => {
    const { search, status } = filter;
    const { defaultSearch, defaultStatus } = defaultFilter;
    const badgeList = [];
    Object.keys(filter).forEach((key) => {
      switch (key) {
        case ('search'):
          if (search && search !== defaultSearch) {
            badgeList.push(
              {
                order: 1,
                title: 'Search',
                desc: filter[key],
                filterKey: key,
              },
            );
          }
          break;
        case ('status'):
          if (status && status !== defaultStatus) {
            badgeList.push(
              {
                order: 1,
                title: 'Status',
                desc: filter[key],
                filterKey: key,
              },
            );
          }
          break;
        // no default
      }
    });
    return badgeList;
  };

  return (
    <IndexTableContainer
      newButtonText="New Product Line"
      newButton
      newFormUri="/inventory/product-lines/new"
      pageTitle="Product Lines"
      searchPlaceholder="Search Name..."
      heads={
        [
          { key: 'id', name: 'ID' },
          { key: 'name', name: 'Name' },
        ]
      }
      filterForm={
        [
          {
            type: 'RadioButtonGroup',
            groupLabel: 'Status',
            filterKey: 'status',
            options: [
              { value: '', label: 'All' },
              { value: 'active', label: 'Active' },
              { value: 'archived', label: 'Archived' },
            ],
          },
        ]
      }
      createRows={createRows}
      buildBadgeList={buildBadgeList}
    />
  );
};

export default ProductLinesIndexContainer;
